import { createContext, useContext } from 'react';
import type { ButtonSize, ButtonVariant } from './ButtonProps';

export interface ButtonBarContextType {
  variant: ButtonVariant;
  size: ButtonSize;
}

export const ButtonBarContext = createContext<ButtonBarContextType | undefined>(undefined);

export function useButtonBarContext() {
  return useContext(ButtonBarContext);
}
